<template>
    <div class="property-search-filters d-none d-md-flex flex-wrap">
        <b-dropdown
                toggle-class="text-truncate d-flex align-items-center align-content-center shadow-none"
                no-flip
                v-for="name in primaryFiltersList"
                class="m-1 d-flex"
                :menu-class="[name]"
                :key="'primary-filter-' + name"
                :no-caret="selectedFilterOptions(name) > 0"
                @hide="(event) => handleHide(event, name)"
        >
            <template v-slot:button-content>
                <h3 class="mb-0 font-weight-bold text-truncate">
                    {{ getFilterText(name) }}
                </h3>
                <b-badge
                        v-if="selectedFilterOptions(name) > 0"
                        variant="primary"
                        class="ml-2 branding-primary-bg-color"
                        pill
                >
                    {{ selectedFilterOptions(name) }}
                </b-badge>
            </template>
            <template v-if="name === 'sale'">
                <div
                    :class="{'border-bottom': !value.isSold}"
                >
                    <component
                            v-model="value['isSold']"
                            :is="getFilterType('isSold')"
                            :options="getFilterOptions('isSold')"
                            class="custom-spacing"
                    />
                </div>
            </template>
            <component
                    v-model="value[name]"
                    :is="getFilterType(name)"
                    :options="getFilterOptions(name)"
            />

            <template v-if="name === 'sale' && !value['isSold']">
                <div class="border-top list-dropdown">
                    <div class="custom-control custom-checkbox my-3">
                        <switch-toggle
                            v-model="value['includePending']"
                            label="Pending & Under Contract"
                            label-position="left"
                        />
                    </div>
                </div>
            </template>
        </b-dropdown>

        <b-dropdown
                no-caret
                toggle-class="d-flex align-items-center shadow-none"
                class="filter-dropdown m-1"
                ref="extraFiltersDropdown"
                right
        >
            <template v-slot:button-content>
                <i
                        class="far fa-ellipsis-h text-black"
                        :class="{'active': !!activeFiltersCount}"
                />
            </template>
            <b-dropdown-form class="scroll-area">
                <div
                        class="d-flex"
                        v-for="(name) in secondaryFiltersList"
                        :key="'secondary-filter-' + name"
                >
                    <b-card
                            :header="getFilterHeader(name)"
                            header-tag="h4"
                            header-class="rounded-0"
                            :body-class="{
                          'd-flex': true,
                          'flex-column': true,
                          'p-0': 'ButtonsDropdown' !== getFilterType(name)
                      }"
                            class="border-0 w-100"
                    >
                        <template v-if="name === 'sale'">
                            <div
                                :class="{'border-bottom': !value.isSold}"
                            >
                                <component
                                    v-model="value['isSold']"
                                    :is="getFilterType('isSold')"
                                    :options="getFilterOptions('isSold')"
                                    class="custom-spacing mb-0"
                                />
                            </div>
                        </template>
                        <component
                                v-model="tempFilter[name]"
                                :is="getFilterType(name)"
                                :options="getFilterOptions(name)"
                        />
                        <template v-if="name === 'sale'">
                            <div class="border-top list-dropdown">
                                <div class="custom-control custom-checkbox my-3">
                                    <switch-toggle
                                        v-model="value['includePending']"
                                        label="Pending & Under Contract"
                                        label-position="left"
                                    />
                                </div>
                            </div>
                        </template>
                    </b-card>
                </div>

                <b-dropdown-header>
                    KEYWORDS
                </b-dropdown-header>
                <b-dropdown-text
                        tag="div"
                        class="checkbox-wrapper p-3"
                        text-class="p-0"
                >
                    <keyword-type-ahead
                            v-model="tempFilter.keywords"
                            :options="FILTER_OPTIONS.KEYWORDS"
                    />
                </b-dropdown-text>

                <b-dropdown-text tag="div">
                    <b-button
                            block
                            variant="primary"
                            size="lg"
                            @click="applyFilters"
                    >
                        Apply Filters
                    </b-button>
                </b-dropdown-text>
            </b-dropdown-form>
        </b-dropdown>


        <property-saved-searches-save-button
                v-if="showSavedSearch"
                class="m-1 ml-auto"
        />
    </div>
</template>
<script>
    import './PropertySearchFilters.scss';

    import RangeDropdown from "../GroupDropdowns/RangeDropdown/RangeDropdown";
    import ButtonsDropdown from "../GroupDropdowns/ButtonsDropdown/ButtonsDropdown";
    import ListDropdown from "../GroupDropdowns/ListDropdown/ListDropdown";
    import cloneDeep from 'lodash/cloneDeep';
    import get from 'lodash/get';
    import * as FILTER_OPTIONS from '../../../../../helpers/filterOptions';
    import PropertySavedSearchesSaveButton
        from "../../../GroupPropertySavedSearches/PropertySavedSearchesSaveButton/PropertySavedSearchesSaveButton";
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import KeywordTypeAhead from "./KeywordTypeAhead/KeywordTypeAhead";
    import RadioDropdown from "../GroupDropdowns/RadioDropdown/RadioDropdown";
    import SwitchToggle from "@milestoneslabs/milestones-ui-kit/src/components/SwitchToggle";

    export default {
        name: 'PropertySearchFilters',
        components: {
            PropertySavedSearchesSaveButton,
            RangeDropdown,
            ButtonsDropdown,
            ListDropdown,
            KeywordTypeAhead,
            RadioDropdown,
            SwitchToggle,
        },
        mixins: [
            IsMobileMixin
        ],
        props: {
            primaryFilters: {
                type: Array,
                default: () => [],
            },
            displaySaveSearch: {
                type: Boolean,
                default: true,
            },
            value: {
                type: Object,
            }
        },
        data() {
            return {
                FILTER_OPTIONS,
                activeFilters: [
                    'price',
                    'beds',
                    'baths',
                    'homeType',
                    'sale',
                    'lotSize',
                    'squareFeet',
                    'yearBuilt',
                ],
                tempFilter: cloneDeep(this.value),
                keywords: [],
                dropdownToggles: {},
            };
        },

        watch: {
            value: {
                deep: true,
                handler() {
                    this.tempFilter = cloneDeep(this.value);
                }
            },
        },

        computed: {
            showSavedSearch() {
                return !this.isMobile && this.displaySaveSearch;
            },

            primaryFiltersList() {
                let self = this,
                    minFieldSizePx = 155,
                    maxDisplayedFilters = (
                        this.windowWidth - minFieldSizePx *
                        (2 + (!this.isMobile && !this.isTablet && this.displaySaveSearch ? 1.3 : 0))
                    ) / minFieldSizePx;
                return this.primaryFilters.filter((filter, index) => {
                    return self.activeFilters.includes(filter) &&
                        (!index || maxDisplayedFilters > index + 1 && index < 5);
                });
            },
            secondaryFiltersList() {
                let self = this;

                return this.activeFilters.filter(
                    filter => !self.primaryFiltersList.includes(filter)
                );
            },

            activeFiltersCount() {
                let count = (this.value.keywords || []).length ? 1 : 0;

                ['primaryFiltersList', 'secondaryFiltersList'].forEach(listName => {
                    this[listName].forEach(key => {
                        if (!this.value[key]) {
                            return;
                        }
                        if (this.value[key] instanceof Object) {
                            count += !!this.value[key].value ||
                                (this.value[key].min || {}).value ||
                                (this.value[key].max || {}).value
                                ? 1 : 0;
                        } else if (this.value[key] instanceof Array) {
                            count += this.value[key].length ? 1 : 0;
                        } else {
                            count += this.value[key] !== '' ? 1 : 0;
                        }
                    });
                });

                return count;
            },

            saleOptions() {
                let options = [];
                if (this.value.isSold) {
                    return options;
                }
                for (let item of FILTER_OPTIONS.SALE_TYPES) {
                    options.push({
                        label: item.label,
                        value: item,
                    });
                }
                return options;
            },

            homeTypeOptions() {
                let options = [];
                for (let item of FILTER_OPTIONS.HOME_TYPES) {
                    options.push({
                        label: item.label,
                        value: item,
                    });
                }
                return options;
            },

            priceText() {
                if (this.secondaryFiltersList.indexOf('price') > -1) {
                    return 'Price';
                }

                if (!get(this.value, 'price.min.value') && !get(this.value, 'price.max.value')) {
                    return 'Any Price';
                }
                let min = get(this.value, 'price.min.label', 'No Min');
                let max = get(this.value, 'price.max.label', 'No Max');

                if (!get(this.value, 'price.max.value')) {
                    return min + '+';
                }

                return min + ' to ' + max;
            },
            bedsText() {
                let beds = this.secondaryFiltersList.indexOf('beds') > -1
                    ? 'Beds' : get(this.value, 'beds.label');

                if (beds && ['Beds', 'Any'].indexOf(beds) === -1) {
                    beds += ' Beds';
                }

                return (beds !== 'Any' ? beds : '') || 'All Beds';
            },
            bathsText() {
                let baths = this.secondaryFiltersList.indexOf('baths') > -1
                    ? 'Baths' : get(this.value, 'baths.label');

                if (baths && ['Baths', 'Any'].indexOf(baths) === -1) {
                    baths += ' Baths';
                }

                return (baths !== 'Any' ? baths : '') || 'All Baths';
            },
            homeTypeText() {
                let text = 'All Home Types';
                if (this.value.homeType.length || this.secondaryFiltersList.indexOf('homeType') > -1) {
                    text = 'Home Types';
                }
                return text;
            },
            saleText() {
                if (this.value.isSold) {
                    return 'Recently Sold';
                }
                let text = 'All For Sale';
                if (this.value.sale.length || this.secondaryFiltersList.indexOf('sale') > -1) {
                    text = 'Listings For Sale';
                }
                return text;
            },
            isSoldText() {
                let text = 'Listings For Sale';
                const item = FILTER_OPTIONS.IS_SOLD.find(item => item.value === this.value.isSold);
                if (item) {
                    text = item.text;
                }
                return text;
            },
        },
        methods: {
            handleHide(event, name) {
                if (this.getFilterType(name) === 'RangeDropdown') {
                    if (this.tempFilter[name].min.value && this.tempFilter[name].max.value) {
                        this.dropdownToggles[name] = false;
                        return;
                    }

                    if (!this.dropdownToggles[name]) {
                        event.preventDefault();
                    }
                    this.dropdownToggles[name] = !(this.tempFilter[name].min.value && this.tempFilter[name].max.value);
                }
            },
            selectedFilterOptions(name) {
                return (this.value[name] || {}).constructor === Array
                    ? this.value[name].length
                    : 0;
            },
            getFilterText(name) {
                return this[name + 'Text'] || '';
            },

            getFilterHeader(name) {
                switch (name) {
                    case 'yearBuilt':
                        return 'YEAR BUILT';
                    case 'lotSize':
                        return 'LOT SIZE';
                    case 'squareFeet':
                        return 'SQUARE FEET';
                    case 'homeType':
                        return 'HOME TYPE';
                    case 'sale':
                        return 'SALE TYPE';
                }

                return this.getFilterText(name).toUpperCase();
            },

            getFilterType(name) {
                switch (name) {
                    case 'beds':
                    case 'baths':
                        return 'ButtonsDropdown';
                    case 'homeType':
                    case 'sale':
                        return 'ListDropdown';
                    case 'isSold':
                        return 'RadioDropdown';
                }

                return 'RangeDropdown';
            },

            getFilterOptions(name) {
                switch (name) {
                    case 'sale':
                        return this.saleOptions;
                    case 'beds':
                        return FILTER_OPTIONS.BEDS;
                    case 'price':
                        return FILTER_OPTIONS.PRICES;
                    case 'baths':
                        return FILTER_OPTIONS.BATHS;
                    case 'yearBuilt':
                        return FILTER_OPTIONS.YEAR_BUILT;
                    case 'lotSize':
                        return FILTER_OPTIONS.LOT_SIZE;
                    case 'squareFeet':
                        return FILTER_OPTIONS.SQUARE_FEET;
                    case 'homeType':
                        return this.homeTypeOptions;
                    case 'isSold':
                        return FILTER_OPTIONS.IS_SOLD;
                }
                return this.getFilterType(name) !== 'RangeDropdown' ? [] : {};
            },

            applyFilters() {
                let self = this;
                this.secondaryFiltersList.forEach(key => {
                    self.value[key] = self.tempFilter[key];
                });
                this.value.keywords = this.tempFilter.keywords;

                this.tempFilter = cloneDeep(this.value);
                this.$refs.extraFiltersDropdown.hide(true);
            },

            handleInput() {
                this.$emit('input', this.value);
            }
        }
    };
</script>